import { FC } from 'react'
import css from 'styled-jsx/css'
import { getCurrency, imagePath } from '@ui/helpers'
import { thumbImage } from '@libs/client'
import { useSetting } from '@ui/hooks'

interface IVariant {
  size?: 'small' | 'normal'
  variant: Types.OrderItem
  title: string
}

const sThumb = thumbImage('96x96')

const Variant: FC<IVariant> = ({ size, variant, title }) => {
  const [sellpageSetting] = useSetting('sellpage')
  function getImageSize() {
    switch (size) {
      case 'small':
        return 'is-4-mobile is-4-tablet is-2-desktop'
      case 'normal':
        return 'is-4-mobile is-4-tablet is-3-desktop'
      default:
        return 'is-4'
    }
  }

  return (
    <>
      <style jsx>{VariantStyle}</style>
      <div className="variant">
        <div className="variant--top columns is-mobile is-variable is-2">
          <div className={`column ${getImageSize()}`}>
            <figure className="variant__image image is-square">
              <picture>
                <source data-srcset={imagePath(variant.imageUrl ?? '')} />
                {sellpageSetting?.fallback_img?.[variant.imageUrl || ''] ? (
                  <source
                    data-srcset={imagePath(sellpageSetting?.fallback_img?.[variant.imageUrl || ''])}
                  />
                ) : (
                  <></>
                )}
                <img
                  className="lazyload"
                  src={sThumb(variant.imageUrl ?? '')}
                  data-src={imagePath(variant.imageUrl ?? '')}
                  alt="variant product"
                />
              </picture>
            </figure>
          </div>
          <div className="column">
            <div className="columns is-vcentered is-variable is-2 mb-0">
              <div className="column pb-1-mobile">
                <div className="variant__title">{title}</div>
                <div className="size--small">
                  <div className="variant__property expand-on-mobile">
                    <p className="property mr-0">
                      {Object.entries(variant.properties ?? {}).map(
                        (property: any, index: number) => {
                          return (
                            <span
                              key={index}
                              className={
                                index != Object.keys(variant.properties ?? {}).length - 1
                                  ? 'mr-6'
                                  : ''
                              }
                            >
                              <strong>{property[0]}</strong>: {property[1]}
                            </span>
                          )
                        }
                      )}
                    </p>
                    <div className="property">
                      <strong>Quantity</strong>: {variant.quantity}
                    </div>
                  </div>

                  <div className="variant__price">
                    {variant.compare_price &&
                    !sellpageSetting?.settings?.configurations.hide_clearance ? (
                      <del className="compared">{getCurrency(variant.compare_price)}</del>
                    ) : null}
                    {getCurrency(variant.price ?? 0)}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {variant.compare_price && !sellpageSetting?.settings?.configurations.hide_clearance && (
          <div className="variant__quantity mobile">
            <div className="variant__price is-pulled-right">
              <del className="compared">{getCurrency(variant.compare_price ?? 0)}</del>
              {getCurrency(variant.price ?? 0)}
            </div>
          </div>
        )}
      </div>
    </>
  )
}

export default Variant

const VariantStyle = css`
  .variant {
    &--top {
      margin-bottom: -12px !important;
    }

    &__image {
      border: solid 1px #e8e8e8;
      border-radius: 5px;

      img {
        border-radius: 4px;
      }
    }

    &__title {
      font-size: 16px;
      line-height: 24px;
      font-weight: bold;
      margin-bottom: 8px;
    }

    &__property {
      display: block;
      flex-wrap: wrap;
      font-size: 12px;
      line-height: 24px;
      text-transform: capitalize;

      @media screen and (max-width: 786px) {
        margin-right: 0;
      }

      //.property:not(:last-child) {
      //  margin-right: 24px;
      //}
    }

    @media screen and (max-width: 575px) {
      .property,
      p {
        max-width: 230px;
      }
    }

    &__quantity {
      align-items: center;
      justify-content: space-between;

      @media screen and (max-width: 786px) {
        &.desktop {
          display: block;

          &.is-flex {
            display: none !important;
          }
        }

        &.mobile {
          display: none;

          .is-flex {
            display: flex;
          }
        }
      }

      @media screen and (min-width: 787px) {
        &.desktop {
          display: block;
        }

        &.mobile {
          display: none !important;
        }
      }
    }

    &__price {
      font-size: 16px;
      display: flex;
      align-items: flex-end;
      justify-content: flex-end;

      .compared {
        font-size: 12px;
        margin-right: 14px;
        color: var(--grey);
      }
    }

    .expand-on-mobile {
      margin-right: -6rem !important;
    }
  }

  .size {
    &--small {
      display: flex;
      justify-content: space-between;
    }
  }
`
